import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 101514 89771"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:1471.22}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970061603344">
        <path
          d="M2366 54697c2176 2173 5698 2173 7874 0s2176-5700 0-7874c-2176-2175-5698-2175-7874 0-2173 2173-2173 5698 0 7874zM17182 39876c2176 2176 5701 2176 7876 0 2174-2173 2174-5698 0-7874-2176-2173-5701-2173-7876 0-2173 2176-2173 5701 0 7874zM32003 25059c2176 2176 5701 2176 7874 0 2176-2173 2176-5698 0-7871-2173-2176-5698-2176-7874 0-2176 2170-2176 5698 0 7871zM46820 10240c2176 2176 5698 2176 7874 0 2176-2173 2176-5700 0-7873-2173-2176-5698-2176-7874 0-2173 2173-2173 5700 0 7873zM99148 54697c-2173 2173-5698 2173-7874 0-2173-2173-2173-5700 0-7874 2176-2175 5701-2175 7874 0 2173 2173 2173 5698 0 7874zM84329 39876c-2173 2176-5698 2176-7874 0-2173-2173-2173-5698 0-7874 2176-2173 5701-2173 7874 0 2176 2176 2176 5701 0 7874zM69512 25059c-2173 2176-5697 2176-7872 0-2176-2173-2176-5698 0-7871 2175-2176 5699-2176 7872 0 2176 2170 2176 5698 0 7871z"
          className="fill stroke1"
          style={{
            strokeWidth: 1471.22,
          }}
        />
        <path
          d="M54694 10240c-2173 2176-5698 2176-7874 0-2176-2173-2176-5700 0-7873 2176-2176 5698-2176 7874 0 2173 2173 2173 5700 0 7873zM2366 87405c2176 2173 5698 2173 7874 0 2176-2176 2176-5698 0-7874-2176-2173-5698-2173-7874 0-2173 2176-2173 5698 0 7874zM17182 72585c2176 2173 5701 2173 7876 0 2174-2173 2174-5698 0-7874-2176-2173-5701-2173-7876 0-2173 2176-2173 5701 0 7874zM32003 57767c2176 2176 5701 2176 7874 0 2176-2173 2176-5698 0-7874-2173-2173-5698-2173-7874 0-2176 2176-2176 5701 0 7874zM46820 42951c2176 2174 5698 2174 7874 0 2176-2175 2176-5700 0-7873-2173-2176-5698-2176-7874 0-2173 2172-2173 5697 0 7873zM99148 87405c-2173 2173-5698 2173-7874 0-2173-2176-2173-5698 0-7874 2176-2173 5701-2173 7874 0 2173 2176 2173 5698 0 7874zM84329 72585c-2173 2173-5698 2173-7874 0-2173-2173-2173-5698 0-7874 2176-2173 5701-2173 7874 0 2176 2176 2176 5701 0 7874zM69512 57767c-2173 2176-5697 2176-7872 0-2176-2173-2176-5698 0-7874 2175-2173 5699-2173 7872 0 2176 2176 2176 5701 0 7874z"
          className="fill stroke1"
          style={{
            strokeWidth: 1471.22,
          }}
        />
        <path
          d="M54694 42951c-2173 2174-5698 2174-7874 0-2176-2175-2176-5700 0-7873 2176-2176 5698-2176 7874 0 2173 2172 2173 5697 0 7873z"
          className="fill stroke1"
          style={{
            strokeWidth: 1471.22,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
